import React from "react";
import { Switch } from "antd";
import { useDashTheme } from "../hooks/useDashTheme";
import { DASH_WIDGETS } from "../dashboardLayout";
import { DashAntd } from "./DashAntd";

/**
 * Instant on/off list for Pulse cards. Used by the dashboard drawer and Settings.
 */
export function DashboardWidgetToggles({ widgets, onToggle, disabled }) {
  const t = useDashTheme();
  const onCount = DASH_WIDGETS.filter((w) => widgets?.[w.id] !== false).length;

  return (
    <DashAntd>
      <div style={{ display: "grid", gap: 8 }}>
        <div style={{
          fontSize: 12, fontWeight: 650, color: t.c.textTertiary,
          letterSpacing: "0.04em", textTransform: "uppercase", padding: "0 2px 2px",
        }}>
          {onCount} of {DASH_WIDGETS.length} showing · for everyone
        </div>
        {DASH_WIDGETS.map((w) => {
          const on = widgets?.[w.id] !== false;
          return (
            <label
              key={w.id}
              style={{
                display: "flex", alignItems: "center", gap: 12,
                padding: "12px 14px", borderRadius: 12,
                border: `1px solid ${on ? t.c.border : t.c.border}`,
                background: on ? t.c.surface : (t.c.surfaceMuted || t.c.surface),
                opacity: on ? 1 : 0.72, cursor: disabled ? "wait" : "pointer",
              }}
            >
              <div style={{ minWidth: 0, flex: 1 }}>
                <div style={{ fontWeight: 700, fontSize: 13.5, color: t.c.text, lineHeight: 1.25 }}>{w.title}</div>
                <div style={{ fontSize: 12, color: t.c.textSecondary, marginTop: 2, lineHeight: 1.4 }}>{w.blurb}</div>
              </div>
              <Switch
                checked={on}
                disabled={disabled}
                onChange={(checked) => onToggle(w.id, checked)}
              />
            </label>
          );
        })}
      </div>
    </DashAntd>
  );
}

export default DashboardWidgetToggles;
